<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <ValidationObserver
          v-slot="{ errors }"
          tag="div"
        >
          <input-form
            ref="form"
            :errors="errors"
            name="LandlordApplicationFrm"
            @submit.prevent="handleSubmit"
          >
            <h1>Check Your Application Status</h1>
            <callout
              type="info"
            >
              Please enter your Applicant ID (starting with EDP2- or EVP-). Your Applicant ID is included in any correspondence you receive from the PHL Eviction Diversion system (emails & text messages).
            </callout>
            <textbox
              v-model.trim="ApplicantId"
              name="txt-applicant-id"
              placeholder="Applicant ID:"
              @keydown.enter.prevent=""
              @change="StatusCheckResult = null"
              @input="SubmitStatus.Value = null"
            />
            <div class="column is-2 is-offset-10">
              <button
                type="button"
                :disabled="[SubmitStatus.Options.PENDING].includes(SubmitStatus)"
                class="button is-primary"
                @click="handleSubmit"
              >
                Check Status
              </button>
            </div>
            <div
              v-if="SubmitStatus.Value === SubmitStatus.Options.OK && ApplicantId.includes('EVP-')"
              class="cell"
            >
              <label for="status-check-result-list">EDP Application Status</label>
              <ul
                v-if="StatusCheckResult"
                id="status-check-result-list"
                name="status-check-result-list"
              >
                <li
                  v-for="(result, idx) in StatusCheckResult"
                  :key="idx"
                >
                  <div v-html="result" />
                </li>
              </ul>
            </div>
            <div
              v-if="SubmitStatus.Value === SubmitStatus.Options.OK && ApplicantId.includes('EDP2-')"
              class="cell"
            >
              <!-- <label for="status-check-result-list">EDP Application Status</label>
              <ul
                v-if="StatusCheckResult"
                id="status-check-result-list"
                name="status-check-result-list"
              >
                <li
                  v-for="(result, idx) in StatusCheckResult"
                  :key="idx"
                > -->
              <div v-html="StatusCheckResult" />
              <!-- </li> -->
            </div>
            <div v-else-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
              Loading...
            </div>
            <div v-else-if="SubmitStatus.Value === SubmitStatus.Options.NOT_FOUND">
              <callout
                message="This application number does not match an application in our database. Please check to make sure it is correct and complete and try again."
                type="danger"
              />
            </div>
            <br>
          </input-form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import options from "@/utilities/options";
import buildStatusCheckDataObject from "@/utilities/data-objects/status-check-data-object";
import buildOldStatusCheckDataObject from "@/utilities/data-objects/status-check-data-object-old-application";
import axios from "axios";
import {
  getPropertyValueOrDefault,
  toAnchorTag,
} from "@/utilities/functions";

export default {
  mixins: [options],
  props: {
    applicantId: { type: String, default: null },
  },
  data() {
    return {
      StatusCheckResult: null,
      ApplicantId: null,
    };
  },
  created() {
    var vData = this;
    if (vData.applicantId) {
      vData.ApplicantId = vData.applicantId;
    }
  },
  methods: {
    async checkOldApplication(ApplicantId){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const dataObject = buildOldStatusCheckDataObject(
        ApplicantId,
        "EDP_STATUS_CHECK_DATA_REQUEST",
      );
      const requestObj = {
        table: "bqseac2yd",
        data: dataObject,
      };
      axios
        .post(
          "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-Secure-Request-Proxy",
          requestObj,
        )
        .then(qbResult => {
          console.log(qbResult);
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          const singleReturnValue = getPropertyValueOrDefault(
            ["data", "record", "f", "_text"],
            qbResult,
          );
          const multipleReturnValue = getPropertyValueOrDefault(
            ["data", "record", "f"],
            qbResult,
          );
          if (singleReturnValue) {
            let cleanReturnValue = singleReturnValue.replace(
              /(\\r)*\\n/g,
              "<br>",
            );
            const isAnchor = /<a[^>]*>([^<]+)<\/a>/g.test(singleReturnValue);
            if (!isAnchor) {
              cleanReturnValue = toAnchorTag(cleanReturnValue);
            }
            vData.StatusCheckResult = cleanReturnValue.split(";");
          } else if (multipleReturnValue) {
            // do something with multiple values...
            vData.StatusCheckResult = multipleReturnValue.map(i => i._text);
          } else {
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            vData.StatusCheckResult = "Record Not Found";
          }
        }).catch(e => {
          this.checkOldApplication(ApplicantId); 
        });
    },
    async checkNewApplication(){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      if(vData.ApplicantId.includes('edp2-')){
        vData.ApplicantId = vData.ApplicantId.replace('edp2-', 'EDP2-');
      }
      if(vData.ApplicantId.includes('evp-')){
        vData.ApplicantId = vData.ApplicantId.replace('evp-', 'EVP-');
      }
      const dataObject = buildStatusCheckDataObject(
        vData.ApplicantId,
        "EDP_STATUS_CHECK_DATA_REQUEST",
      );
      const requestObj = {
        table: process.env.VUE_APP_QB_APPLICATION,
        data: dataObject,
      };
      axios
        .post(
          "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/EDP-TFA-login-QuickBase-Request-Proxy-Reads",
          requestObj,
        )
        .then(qbResult => {
          if(vData.ApplicantId.includes('EVP-') || vData.ApplicantId.includes('evp-')){
            this.checkOldApplication(vData.ApplicantId);
          } else{
          
            const singleReturnValue = getPropertyValueOrDefault(
              ["data", "record", "f"],
              qbResult,
            );

            if(!singleReturnValue){
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.NOT_FOUND;
              vData.StatusCheckResult = "Record Not Found";
              return;
            }
            const statusValue = getPropertyValueOrDefault(["_text"], singleReturnValue.find(i => i._attributes.id === "175"));
            //const oldApplicantId = getPropertyValueOrDefault(["_text"], singleReturnValue.find(i => i._attributes.id === "1030"));
          
            if(statusValue != null){
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
              vData.StatusCheckResult = statusValue;
            }else{
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.NOT_FOUND;
              vData.StatusCheckResult = "Record Not Found";
            }
          }
          
          
          
          // const multipleReturnValue = getPropertyValueOrDefault(
          //   ["data", "record", "f"],
          //   qbResult,
          // );
          // if (singleReturnValue) {
          //   let cleanReturnValue = singleReturnValue.replace(
          //     /(\\r)*\\n/g,
          //     "<br>",
          //   );
          //   const isAnchor = /<a[^>]*>([^<]+)<\/a>/g.test(singleReturnValue);
          //   if (!isAnchor) {
          //     cleanReturnValue = toAnchorTag(cleanReturnValue);
          //   }
          //   vData.StatusCheckResult = cleanReturnValue.split(";");
          // } else if (multipleReturnValue) {
          //   // do something with multiple values...
          //   vData.StatusCheckResult = multipleReturnValue.map(i => i._text);
          // } else {
          //   vData.SubmitStatus.Value = vData.SubmitStatus.Options.NOT_FOUND;
          // }
        }).catch(function(error) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          }
          vData.statusResult = "This application number does not match an application in our database. Please check to make sure it is correct and complete and try again.";
        });
    },
    async handleSubmit() {
      this.checkNewApplication();
    },
  },
};
</script>

<style></style>
